import { array, object, string } from 'yup'
import { avoid } from './shared/avoid'
import { topic } from './shared/topic'
import { audience } from './shared/audience'
import { callToAction } from './shared/callToAction'
import { language } from './shared/language'
import { newsletterStyle } from './shared/newsletterStyle'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { MultiStepSchema, StepSchema } from 'components/Wizards/schemas/Types'
import { FormSchema } from '../Wizard/Form/Types'
import { filename } from './shared/filename'
import { project } from './shared/project'
import { sourceMaterialIds } from './shared/sourceMaterials'
import { brandVoiceId, tone } from './shared/voiceTones'
import { brandKitId } from './shared/brandKitId'
import { count } from './shared/count'
import { safify } from './utils/safify'
import { DynamicHighDetailedMail } from 'blaze-ui/icons/40'

export const newsletterMeta = {
  type: ChannelType.Newsletter,
  icon: DynamicHighDetailedMail,
  steps: ['Goals & Outline', 'Subject Line', 'Sections & Images'],
  title: 'Email Newsletter',
  submitLabel: 'Generate',
  previewUrl:
    'https://res.cloudinary.com/almanac/image/upload/v1710183789/Home%20Card%20Previews/evyharyawjck2cr8jmru.png',
}

export const topicFieldPromotional = topic.meta({
  generationType: newsletterMeta.type,
  label: 'What is the purpose of your email?',
  placeholder: "Ex: I'm promoting 20% off our new product",
  withBrandKit: true,
})

export const topicFieldAnnouncement = topic.meta({
  generationType: newsletterMeta.type,
  label: 'What is the purpose of your email?',
  placeholder: "Ex: I'll be promoting my new book at City Lights Book Store",
  withBrandKit: true,
})

export const topicFieldEditorial = topic.meta({
  generationType: newsletterMeta.type,
  label: 'What is the purpose of your email?',
  placeholder: "Ex: I'm sharing beginner friendly investing tips",
  withBrandKit: true,
})

export const topicFieldWeeklyUpdate = topic.meta({
  generationType: newsletterMeta.type,
  label: 'What is the purpose of your email?',
  placeholder: "Ex: I'm launching 4 new products this week!",
  withBrandKit: true,
})

export const firstStepFields = {
  newsletter_style: newsletterStyle.required().meta({ label: 'Select Newsletter Type' }),
  topic: topic.meta({
    generationType: newsletterMeta.type,
    label: 'What is the purpose of your email?',
    placeholder: 'Are you promoting an offer, writing an editorial story, have an announcement or sharing an update?',
    withBrandKit: true,
  }),
  brand_voice_id: brandVoiceId,
  brand_kit_id: brandKitId,
  source_material_ids: sourceMaterialIds,
  tone,
  audience: audience.meta({ label: 'Who is the target audience?' }),
  count: count.default(3).min(1).max(10).meta({
    label: 'How many sections do you want? (Max 10)',
    description: 'We recommended 3 sections for an engaging newsletter.',
  }),
  language,
  filename,
  project: project.required(),
  call_to_action: callToAction.meta({ collapsible: true }),
  avoid: avoid.meta({ collapsible: true }),
}

export const EmailNewsletterSchema = object(firstStepFields).meta(newsletterMeta) as FormSchema<ChannelType>

export const EmailNewsletterMultiStepSchema: MultiStepSchema<ChannelType.Newsletter> = {
  steps: [
    EmailNewsletterSchema.meta({ submitLabel: 'Pick a Subject Line', title: 'Goals & Outline' }) as StepSchema,
    object({ selected_subject_line_id: string().required() }).meta({
      submitLabel: 'Adjust Sections & Images',
      title: 'Subject Line',
    }) as StepSchema,
    object({
      introduction: string().required().meta({ label: 'Intro Section' }),
      section_titles: array()
        .of(string().required())
        .default([])
        .meta({
          label: 'Section Titles & Images',
          description: 'Edit, delete, add images and rearrange your sections below.',
        })
        .transform(safify),
      section_images: array().of(string()).default([]).transform(safify),
    }).meta({
      submitLabel: 'Generate',
      title: 'Sections & Images',
    }) as StepSchema,
  ],
  meta: {
    ...newsletterMeta,
    type: ChannelType.Newsletter,
    channel: ChannelType.Newsletter,
  },
}
